import React, { useEffect, useState } from "react";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import ImgHeaderSubheader from "../../../components/SignUpLoginForgot/ImgHeaderSubheader";
import StyledLink from "../../../components/StyledLink";
import Button from "../../../components/Button";
import LabelLink from "../../../components/SignUpLoginForgot/LabelLink";
import { Colors, Text } from "../../../config";
import { useNavigate } from "react-router-dom";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import LoginInputfield from "../../../components/SignUpLoginForgot/LoginInputfield";
import {
  FlexEnd,
  FlexWithGap,
  LoginInnerWrapperOther,
  LoginLayout,
  WidthWrapper,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import { validateLogin } from "./ValidateLogin";
import { login, tokenRegister } from "../../../services/userServices";
import ErrorSuccessModal from "../../../components/ErrorSuccessModal";
import { useLoaderContext } from "../../../contexts/loaderContext";
// import { requestForToken } from "../../../firebaseNotifications/firebase";

const loginIcon = require("../../../assets/images/LoginIcon.png");

const LoginEmployee = () => {
  const navigate = useNavigate();
  const [employeeID, setEmployeeID] = useState("");
  const [employeePIN, setEmployeePIN] = useState("");
  const [employeeIDError, setEmployeeIDError] = useState("");
  const [employeePINError, setEmployeePINError] = useState("");
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [notRegistered, setNotRegistered] = useState(false);
  const { setLoader } = useLoaderContext();

  useEffect(() => {
    // localStorage.clear();
  }, []);

  const handleChange = (e) => {
    const inpName = e.target.name;
    if (inpName === "empId") {
      setEmployeeID(e.target.value);
      setEmployeeIDError("");
    }
    if (inpName === "empPin") {
      setEmployeePIN(e.target.value);
      setEmployeePINError("");
    }
  };

  const handleLogin = () => {
    if (
      !validateLogin(
        employeeID,
        employeePIN,
        setEmployeeIDError,
        setEmployeePINError
      )
    ) {
      const loginData = {
        empId: employeeID,
        pin: employeePIN,
      };
      postLoginData(loginData);
    }
  };
  const postLoginData = async (loginData) => {
    console.log(loginData);
    setLoader(true);
    try {
      const response = await login(loginData);
      // let responseToken = await requestForToken();

      if (response.status === 201) {
        setLoader(false);
        let responseData = response.data.data;
        if (responseData.redirectPage === "OTPPage") {
          setNotRegistered(Text.pleaseContinueRegistration);
          localStorage.setItem("userId", responseData.userId);
          localStorage.setItem("phone", responseData.phone);
        } else {
          localStorage.setItem("token", responseData.token);
          localStorage.setItem("userId", responseData.userId);
          localStorage.setItem("roleEmployee", "employee");
          localStorage.setItem("shownTutorial", responseData?.isVideoViewed);
          // localStorage.setItem("firebaseEmployeeToken", responseToken);
          const employeeData = {
            firstName: responseData.firstName,
            lastName: responseData.lastName,
            email: responseData.email,
          };
          localStorage.setItem("employeeData", JSON.stringify(employeeData));
          // await tokenRegister({ token: responseToken });
          navigate("/user/dashboard");
        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };
  const handleForgotPin = () => {
    navigate("/auth/forgot");
  };

  const handleSignUp = () => {
    navigate("/auth/signup");
  };

  const handleBackClick = () => {
    navigate("/auth/login");
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const closeNotRegisteredModal = () => {
    setNotRegistered(false);
    navigate("/auth/signup/otp");
  };

  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <ImgHeaderSubheader
            header={Text.welcomeBack}
            subheader={Text.signInAndUnlockYourTravelPlanswithUS}
          />
          <WidthWrapper maxWidth="22.5rem">
            <FlexWithGap gap="2rem">
              <FlexWithGap gap="1rem">
                <FlexWithGap gap="1rem">
                  <LoginInputfield
                    label={Text.employeeID}
                    placeholder={Text.enterEmployeeID}
                    value={employeeID}
                    name="empId"
                    onChange={handleChange}
                    errorText={employeeIDError}
                  />
                  <LoginInputfield
                    label={Text.pin}
                    placeholder={Text.enterYourPin}
                    value={employeePIN}
                    name="empPin"
                    onChange={handleChange}
                    type="password"
                    showHidePassword={showPassword}
                    setShowHidePassword={setShowPassword}
                    errorText={employeePINError}
                  />
                </FlexWithGap>
                <FlexEnd>
                  <StyledLink
                    linkText={Text.forgotPin}
                    handleClick={handleForgotPin}
                    linkTextColor={Colors.brandTwo}
                  />
                </FlexEnd>
              </FlexWithGap>
              <Button
                label={Text.login}
                onClick={handleLogin}
                rightImgSrc={loginIcon}
                fontColor={Colors.white}
                fontSize="1.375rem"
                fontWeight="700"
                bgColor={Colors.brandTwo}
                topBottomPadding="0.8rem"
                labelImgGap="0.5rem"
              />
            </FlexWithGap>
          </WidthWrapper>
          <LabelLink
            labelText={Text.dontHaveAnAccount}
            linkText={Text.signUp}
            handleClick={handleSignUp}
          />
        </LoginInnerWrapperOther>
      </LoginLayout>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
      {notRegistered && (
        <ErrorSuccessModal
          headerText={Text.dontHaveAnAccountError}
          subheaderText={notRegistered}
          setClose={closeNotRegisteredModal}
          buttonText={Text.continue}
          onButtonClick={closeNotRegisteredModal}
        />
      )}
    </>
  );
};

export default LoginEmployee;
